import { useState, useCallback } from "react";
import { toastService } from "../../../providers";
import { useToggleMerchantStatus } from "../../../hooks/queries/useMerchantQueries";
import { extractAxiosErrorMessage } from "../../../services/utils/errorUtils";

export const useMerchantTableHandlers = () => {
  const [loadingIds, setLoadingIds] = useState(new Set());
  const { mutateAsync: toggleMerchantStatus } = useToggleMerchantStatus();

  const handleToggleStatus = useCallback(
    async (merchant) => {
      const merchantId = merchant.merchantId;
      const isCurrentlyActive = merchant.accountStatus;
      setLoadingIds((prev) => new Set(prev).add(merchantId));
      const actionType = isCurrentlyActive ? "DEACTIVATE" : "ACTIVATE";
      try {
        toastService.info(
          `${actionType === "ACTIVATE" ? "Activating" : "Deactivating"} ${
            merchant.merchantName
          }...`,
        );

        await toggleMerchantStatus({
          merchantId,
          actionType,
        });

        toastService.success(
          `${merchant.merchantName} has been ${
            actionType === "ACTIVATE" ? "activated" : "deactivated"
          } successfully!`,
        );
      } catch (error) {
        toastService.error(
          extractAxiosErrorMessage(
            error,
            `Failed to ${actionType === "ACTIVATE" ? "activate" : "deactivate"} merchant.`,
          ),
        );
      } finally {
        setLoadingIds((prev) => {
          const updated = new Set(prev);
          updated.delete(merchantId);
          return updated;
        });
      }
    },
    [toggleMerchantStatus],
  );

  return {
    loadingIds,
    handleToggleStatus,
  };
};

export default useMerchantTableHandlers;
